import { render, staticRenderFns } from "./krasStatus.vue?vue&type=template&id=a561ab48"
import script from "./krasStatus.vue?vue&type=script&lang=js"
export * from "./krasStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a561ab48')) {
      api.createRecord('a561ab48', component.options)
    } else {
      api.reload('a561ab48', component.options)
    }
    module.hot.accept("./krasStatus.vue?vue&type=template&id=a561ab48", function () {
      api.rerender('a561ab48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/krasStatus.vue"
export default component.exports